(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/filter-and-sort.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/filter-and-sort.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui = svs.ui,
  Button = _svs$ui.ReactButton,
  _svs$ui$ReactBottomSh = _svs$ui.ReactBottomSheet,
  BottomSheet = _svs$ui$ReactBottomSh.BottomSheet,
  BottomSheetFooter = _svs$ui$ReactBottomSh.BottomSheetFooter,
  Badge = _svs$ui.ReactBadge;
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef,
  useMemo = _React.useMemo;
const useFocusTrap = svs.components.lbUtils.useFocusTrap;
const _svs$components$casin = svs.components.casino_react.hooks,
  useSetSearchParams = _svs$components$casin.useSetSearchParams,
  useSearchParams = _svs$components$casin.useSearchParams;
const _svs$components$casin2 = svs.components.casino_react.filterAndSort.components,
  Sort = _svs$components$casin2.Sort,
  Filter = _svs$components$casin2.Filter;
const bottomSheetState = {
  CLOSED: 'closed'
};
const label = 'Filtrera & sortera';
const FilterAndSort = _ref => {
  let _ref$includeProviderF = _ref.includeProviderFilters,
    includeProviderFilters = _ref$includeProviderF === void 0 ? true : _ref$includeProviderF;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  const _useSetSearchParams = useSetSearchParams(),
    clearFilterParams = _useSetSearchParams.clearFilterParams;
  const searchParams = useSearchParams();
  const numberOfActiveFilters = useMemo(() => searchParams.categories.length + (includeProviderFilters ? searchParams.providers.length : 0) + searchParams.tags.length, [searchParams, includeProviderFilters]);
  const contentRef = useRef();
  const _useFocusTrap = useFocusTrap({
      refocus: true,
      onEscape: () => {
        releaseFocus();
        setShowModal(false);
      },
      ariaHiddenElements: ['#main-content', '.fixed-top-content']
    }),
    releaseFocus = _useFocusTrap.releaseFocus,
    trapFocus = _useFocusTrap.trapFocus;
  const onBottomSheetStateChange = state => {
    if (state.state === bottomSheetState.CLOSED) {
      setShowModal(false);
      releaseFocus();
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(Button, {
    "aria-label": label,
    className: "casino-filter-and-sort__sort-button",
    iconPosition: "left",
    onClick: e => {
      e.preventDefault();
      setShowModal(true);
      if (contentRef.current) {
        trapFocus(contentRef.current);
      }
    },
    transparent: true
  }, label, numberOfActiveFilters > 0 && React.createElement(Badge, {
    bounce: true,
    className: "casino-filter-and-sort__filter-section-badge badge-casino",
    size: "small"
  }, numberOfActiveFilters)), React.createElement(BottomSheet, {
    behavior: "modal",
    className: "casino-filter-and-sort",
    disablePageContentSpacing: true,
    headerTitle: label,
    inverted: true,
    isFixed: true,
    isVisible: showModal,
    onStateChange: state => {
      onBottomSheetStateChange(state);
    }
  }, React.createElement("div", {
    ref: contentRef
  }, React.createElement(Sort, null), React.createElement(Filter, {
    includeProviders: includeProviderFilters
  }), React.createElement(BottomSheetFooter, {
    className: "casino-filter-and-sort__bottom-sheet-footer"
  }, React.createElement(Button, {
    "aria-label": "Rensa filter",
    block: true,
    inverted: true,
    onClick: () => {
      clearFilterParams(includeProviderFilters);
      releaseFocus();
      setShowModal(false);
    },
    transparent: true
  }, "Rensa filter"), React.createElement(Button, {
    "aria-label": "Klar",
    block: true,
    onClick: () => {
      releaseFocus();
      setShowModal(false);
    }
  }, "Klar")))));
};
setGlobal('svs.components.casino_react.filterAndSort.FilterAndSort', FilterAndSort);

 })(window);